<template>
    <div class="photoForCredentialsUploader alignC">
        <div style="padding: 0 30px;">
            <label class="uploader">
                <img class="image roundBorder8" :src="imageUrl" v-if="imageUrl"/>
                <img class="image" v-else src="form/photoForCredentials.png" width="100%" height="auto" alt=""/>
                <input type="file" class="hidden" @change="onChangeImage"/>
            </label>
        </div>
    </div>
</template>

<script>
import fileApi from "@api/file";

import appHelper from '@/util/appHelper';

export default {
    /* 证件照片上传器 */
    name: "photoForCredentialsUploader",
    props : {
        value : {
            type : String,
            default : ''
        }
    },
    data() {
        return {
            imageUrl : ''
        }
    },
    methods : {
        setValue(value) {
            this.imageUrl = value;
        },
        onChangeImage(event) {
            let e = event.currentTarget;
            let file = e.files ? e.files[0] : null;
            if (!file)
            {
                return;
            }

            fileApi.uploadImage(file).then((res) => {

                let result = res.data;
                if (typeof(result) === 'string')
                {
                    result = JSON.parse(result);
                }
                this.imageUrl = result.data;
                this.$emit('change', this.imageUrl);
                this.$emit('input',  this.imageUrl);
            }).catch((error) => {
                appHelper.generalAjaxError(error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.uploader {
    display: inline-block;
    .image {
        width: 100%;
        height: auto;
    }
}
</style>
